<template>
	<div class="videoDetails">
		<div class="main-banner" :style="'background-image: url('+bannerList+');'">
			<div class="banner-title">
				<h2>工程案例</h2>
				<h3>Case</h3>
			</div>
		</div>
		<div class="container">
			<div class="main">
				<div class="text">
					<h2>{{$AppLang == 'en' ? videoData.nameEn :videoData.name}}</h2>
					<p>{{$AppLang == 'en' ? videoData.videoDescEn :videoData.videoDesc}}</p>
				</div>
        <video :src="videoData.url" controls></video>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'videos',
	data() {
		return {
			videoData:{},
			bannerList: [],
		};
	},
	mounted(){
		this.bannerApi();
	},
	created(){
		var that = this;
		var videoId = '';
		videoId = this.$route.query.videoId;

		that.$api.post(
			'/video/videoInfo',
			{
				videoId: videoId
			},
			function(res) {
				if(res.data.rtnCode == 200){
					var list = res.data.data;
					that.videoData = list;
				}else{
					alert(res.data.msg);
				}
			}
		);
	},
	methods: {
		bannerApi(){
			var that = this;
			//banner请求接口
			that.$api.post(
				'banner/websiteBanners',
				{
					type: 2
				},
				function(res) {
					if(res.data.rtnCode == 200){
						var list = res.data.data;
						for(var i=0;i<list.length;i++){
							if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))){
								list[i].banner = list[i].phone_banner;
							}else{
								list[i].banner = list[i].pic;
							}
						}
						that.bannerList = list[0].banner;
					}else{
						alert(res.data.msg);
					}

				}
			);
		}
	},
  metaInfo: {
    title: '佛山鼎吉-工程案例', // set a title
    meta: [{ // set meta
      name: 'keywords',
      content: '鼎吉,鼎吉官网,陶瓷墙地砖拣选包装自动化设备,研发、设计、制造、安装为一体的高新技术型企业,佛山市鼎吉包装技术有限公司'
    },
    { // set meta
      name: 'description',
      content: '佛山市鼎吉包装技术有限公司成立于2008年,是一家集研发、设计、制造、安装为一体的高新技术型企业。专业致力于研发生产陶瓷墙地砖拣选包装自动化设备。公司遵循“以市场为导向、以研发为动力、以质量为核心竞争力”的发展宗旨服务建陶企业，为建陶产业的生产自动化和可持续发展做贡献。'
    }],
    link: [{ // set link
      rel: 'asstes',
      href: 'https://www.dinovor.com/'
    }]
  }
}
</script>

<style>
.videoDetails{
	background-color: #fff;
  /* height: 600px; */
}
.videoDetails .main-banner{
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}
.videoDetails .main{
	margin-top: 80px;
	padding-bottom: 60px;
}
.videoDetails .main .text{
	padding: 0 20px;
	padding-bottom: 50px;
	border-bottom: 1px dashed #aeaeae;
	margin-bottom: 60px;
}
.videoDetails .main .text h2{
	margin-bottom: 20px;
	font-size: 20px;
	text-align: center;
}
.videoDetails .main .text p{
	font-size: 12px;
	color: #666666;
	text-align: center;
	line-height: 20px;
}
.videoDetails .main video{
	width: 100%;
  max-height: 600px;
}
@media (max-width: 992px){

}

</style>



// WEBPACK FOOTER //
// src/components/video/video-details.vue